import { Object as FabricObject } from 'fabric/fabric-impl';

// Only the ImGame brand-mark assets (`logo-factory.ts`'s `LOGO_ASSET_SRC`) are
// rebased: the logo plugin keeps the serialized `src` as is, so a template saved
// on the test stand would otherwise keep loading its logo from there. Any other
// absolute URL is left alone — rewriting the unknown is riskier than keeping it.
const LOGO_ASSET_URL = /^https?:\/\/[^/]+(\/images\/logo-(?:square|horizontal|vertical)\.svg)$/;

function rebaseObject(object: FabricObject, origin: string): FabricObject {
  const raw = object as unknown as Record<string, unknown>;
  let next: Record<string, unknown> | null = null;

  if (typeof raw.src === 'string') {
    const match = LOGO_ASSET_URL.exec(raw.src);
    if (match) {
      const src = `${origin}${match[1]}`;
      if (src !== raw.src) next = { ...raw, src };
    }
  }

  if (Array.isArray(raw.objects)) {
    const children = raw.objects as FabricObject[];
    const rebased = children.map((child) => rebaseObject(child, origin));
    if (rebased.some((child, i) => child !== children[i])) {
      next = { ...(next ?? raw), objects: rebased };
    }
  }

  return (next ?? raw) as unknown as FabricObject;
}

/**
 * Points the logo assets at `origin` (the stand the file is imported into),
 * walking into groups. Returns a new array; untouched objects are reused, the
 * input is never mutated.
 */
export function rebaseAssetUrls(objects: readonly FabricObject[], origin: string): FabricObject[] {
  const base = origin.replace(/\/+$/, '');
  return objects.map((object) => rebaseObject(object, base));
}
